import { render } from "./WorkExperience.vue?vue&type=template&id=95093e10&scoped=true"
import script from "./WorkExperience.vue?vue&type=script&lang=js"
export * from "./WorkExperience.vue?vue&type=script&lang=js"

import "./WorkExperience.vue?vue&type=style&index=0&id=95093e10&lang=scss&scoped=true"

import exportComponent from "/home/forge/s.thebuyhive.com/expertsourcing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95093e10"]])

export default __exports__